import { Splide } from '@splidejs/splide';
import { Intersection } from '@splidejs/splide-extension-intersection';

export const homeSlider = {
    init: () => {
        const $ = jQuery;

        const slider = $('#home-slider');

        if ( slider.length !== 1 ) {
            return;
        }

        const homeSplide = new Splide( '#home-slider-splide', {
            type: 'loop',
            autoplay: 'pause',
            pagination: false,
            intersection: {
                inView: {
                    autoplay: true,
                },
                outView: {
                    autoplay: false,
                },
            } 
        } ).mount( { Intersection } );

        const modalTriggers = $('#home-slider-splide .button');

        const modals = $('#slider-overlay .modal');

        modalTriggers.on('click', (e) => {
            e.preventDefault();

            const href =  e.currentTarget.href;
            const hrefArray = href.split('#');

            const modalHash = '#' + hrefArray[hrefArray.length - 1];

            modals.each((i, modal) => {
                const hash = $(modal).data('case-study');

                if (modalHash === hash) {
                    $(modal).show();
                } else {
                    $(modal).hide();
                }
            });

            $('body').addClass('show-overlay');
        });
    }
}